import $ from "jquery";
import LZString from "lz-string";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import SessionManager from "../../routes/SessionManager";
import Loading from "../Loading";
import SensorInfo from "./SensorInfo";
import DateUtil from "../../util/DateUtil";
import DownloadReport from "../common/DownloadReport";
import { DatePicker } from "antd";

const StandardDailyReport = (props) => {

  var sessionMgr = new SessionManager();
  let user = sessionMgr.readCookie("user");

  const [sdr_url, setSdrUrl] = useState("");
  const [person_info, setPersonInfo] = useState({});
  const [date, setDate] = useState(props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD"));
  const [sensor_info, setSensorInfo] = useState({});
  const [zones, setZones] = useState({});
  const [loading, setLoading] = useState(false);
  const [timezone, setTimezone] = useState('America/chicago');
  const [chart_data, setChartData] = useState(null);

  let work_hours = DateUtil.getConfiguredWorkHours(user.site_selected).work_hours;

  useEffect(() => {
    let timeZone = user.site_selected.site_iana_timezone;
    setTimezone(timeZone);
    let zones = {};
    for (var z of user.zones) {
      zones[z.location_id] = z;
    }
    setZones(zones);
    if (!timezone) {
      let timeZoone = moment.tz.guess();
      setTimezone(timeZoone);
    }
    if (Object.keys(zones).length === 0) {
      setLoading(false);
    }
    if (Object.keys(zones).length !== 0) {
      setLoading(true);
      if (user.site_selected) {
        let site_info = user.site_selected.site_name + " at " + moment.tz(new Date(), timezone).format("MM-DD-YYYY hh:mm a");
        setSdrUrl("https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/export-pdf/standard-daily-report/Standard Daily Report - " + site_info + ".pdf?" + LZString.compressToBase64(JSON.stringify(user)) + "=payload&host=" + window.location.host)
        fetchStandardDailyReport(zones);
      }
    }
  }, [date]);

  useEffect(() => {
    if (chart_data !== null) {
      if (user.site_selected) {
        let site_info = user.site_selected.site_name + "_" + Buffer.from(user.user_login).toString('base64') + "_" + date;
        var minifiedUser = preparePDFData({ ...user });
        minifiedUser.date = date;
        minifiedUser.is_today = minifiedUser.date && minifiedUser.date === moment().format("YYYY-MM-DD");
        minifiedUser.save_report = true;
        minifiedUser.request_id = "Standard Daily Report - " + site_info + ".pdf";
        setSdrUrl("https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/pdf/standard-daily-report/Standard Daily Report - " + site_info + ".pdf?" + LZString.compressToBase64(JSON.stringify(minifiedUser)) + "=payload&host=" + window.location.host);
        setLoading(false);
        $(".datepicker").attr("readonly", "true");
      }
    }
  }, [chart_data]);


  let fetchStandardDailyReport = (zones) => {
    var payload = {
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      date: date ? date : moment().format("YYYY-MM-DD"),
      timezone: timezone,
      work_hours_start: work_hours.work_hours_start,
      work_hours_end: work_hours.work_hours_end.replace(":00", ":59"),
    };

    setDate(date);
    setLoading(true);

    $.ajax({
      url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/standard-daily-report",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: JSON.stringify(payload),
    }).then(
      (res) => {
        // console.log({res})
        if (res.status && res.status.code === 200) {
          var data = res.data;
          $(".datepicker").attr("readonly", "true");
          data.sensor_infos = {};

          for (let z1 in data.sensor_info) {
            data.sensor_infos[z1] = [];

            var sensorInfoRecs = data.sensor_info[z1];
            var sensorData = [];
            var personsMap = {};
            var images = [null, null, null];
            let persons = [null, null, null];

            var p1 = data.person_info[z1];
            var personTimeStamps = [p1.start_person_ts, p1.max_person_ts, p1.last_person_ts];

            personsMap[p1.start_person_ts] = p1.start_person_count;
            personsMap[p1.max_person_ts] = p1.max_person_count;
            personsMap[p1.last_person_ts] = p1.last_person_count;

            for (let sensorInfoRec of sensorInfoRecs) {
              var sensor_recs = JSON.parse(sensorInfoRec.sensor_info);
              let y = sensorInfoRec.dev_timestamp;
              let yStr = moment
                .tz(sensorInfoRec.dev_timestamp * 1000, timezone)
                .format("MMM DD, YYYY HH:mm");

              for (let sensor_rec of sensor_recs) {
                sensor_rec.dev_timestamp = yStr;
                sensor_rec.howMany = personTimeStamps.filter(function (x) {
                  return x === y;
                }).length;
                sensor_rec.pos = personTimeStamps.lastIndexOf(y);

                for (let i = 2; i >= 0; i--) {
                  var hr = moment.tz(sensorInfoRec.dev_timestamp * 1000, timezone).format("h a").toUpperCase();
                  hr = hr.length === 4 ? "0" + hr : hr;
                  if (images[i] && i < sensor_rec.pos) {
                    break;
                  } else {
                    images[i] = sensorInfoRec.image;
                    persons[i] = { dev_timestamp: hr, person_count: personsMap[y] };
                  }
                }
              }

              sensorData = sensorData.concat(sensor_recs);
            }

            if (sensorData.length > 0) {
              var sensorCombi = {};
              var sensorInfo = {};
              data.sensor_infos[z1].push({ images: images, persons: persons, sensorInfo: sensorInfo });
              var sensorCount = 0;
              for (let s of sensorData) {
                let combi = s.device_id + "-" + s.name;
                let d = sensorCombi[combi];
                if (!d) {
                  d = sensorCombi[combi] = s.device_id === s.name ? "Gateway" : "Sensor" + ++sensorCount + ": " + s.name;
                }

                if (!sensorInfo[d]) sensorInfo[d] = {};

                if (!sensorInfo[d][s.sensor_id]) {
                  sensorInfo[d][s.sensor_id] = [null, null, null];
                }

                //var finalTS = moment.tz(personTimeStamps[2] * 1000, this.timezone).format('MMM DD, YYYY HH:mm');

                if (!sensorInfo[d][d]) sensorInfo[d][d] = [null, null, null];

                var pos = s.pos;
                for (let i = 2; i >= 0; i--) {
                  if (sensorInfo[d][d][i] && i < pos) {
                    break;
                  } else {
                    sensorInfo[d][d][i] = s.lastupdate ? moment.tz(s.lastupdate * 1000, timezone).format("MMM DD, YYYY HH:mm") : s.dev_timestamp;
                  }
                }

                for (let i = 2; i >= 0; i--) {
                  if (sensorInfo[d][s.sensor_id][i] && i < pos) {
                    break;
                  } else {
                    sensorInfo[d][s.sensor_id][i] = s;
                  }
                }
              }
            }
          }
          // Chart Data Preparation.
          var chartData = {};

          var hrs = DateUtil.getWorkHours(work_hours, "hh A");
          for (let z in zones) {
            let persons = [];
            for (let i in hrs) {
              persons[i] = 0;
            }
            var zoneChartData = data.person_info_full[z];
            if (zoneChartData) {
              for (let rec of zoneChartData) {
                let hr = moment.tz(rec.dev_timestamp * 1000, timezone).format("h a").toUpperCase();
                hr = hr.length === 4 ? "0" + hr : hr;

                var idx = hrs.indexOf(hr);
                if (idx !== -1) {
                  if (persons[idx] < rec.person_count) {
                    persons[idx] = rec.person_count;
                  }
                }
              }
            }
            const array = persons;
            chartData[z] = {
              labels: hrs,
              personsFound: false,
              datasets: [
                {
                  label: "People",
                  backgroundColor: "rgba(0,123,255,0.8)",
                  borderWidth: 0,
                  hoverBackgroundColor: "rgba(0,123,255,0.9)",
                  data: persons,
                },
              ],
            };
            if (Math.max(...array) > 0) {
              chartData[z].personsFound = true;
            } else {
              chartData[z].personsFound = false;
            }
          }
          setPersonInfo(data.person_info);
          setSensorInfo(data.sensor_infos);
          setChartData(chartData);
        }
      },
      (res) => {
        setLoading(false);
        $(".datepicker").attr("readonly", "true");
      }
    );
  }

  let preparePDFData = (userCopy) => {
    var pdfData = {};
    let flds = ["user_login", "user_token", "site_id", "customer_id"];
    for (let i = 0; i < flds.length; i++) {
      pdfData[flds[i]] = userCopy[flds[i]];
    }

    if (userCopy.site_selected) {
      pdfData.site_selected = {};
      let flds = ["site_id", "site_name", "site_iana_timezone", "site_city", "site_country", "site_config"];
      for (let i = 0; i < flds.length; i++) {
        pdfData.site_selected[flds[i]] = userCopy.site_selected[flds[i]];
      }
    }

    if (userCopy.zone_selected) {
      pdfData.zone_selected = {};
      let flds = ["location_id"];
      for (let i = 0; i < flds.length; i++) {
        pdfData.zone_selected[flds[i]] = userCopy.zone_selected[flds[i]];
      }
    }

    if (userCopy.zones) {
      pdfData.zones = [];
      for (let z of userCopy.zones) {
        if (z.location_device_type) {
          pdfData.zones.push({
            location_device_type: z.location_device_type,
            location_name: z.location_name,
            location_id: z.location_id,
            detect_motion: ((z.location_config === undefined || z.location_config.feature_controls === undefined || z.location_config.feature_controls.motion_detection === undefined) || (z.location_config && z.location_config.feature_controls && z.location_config.feature_controls.motion_detection.enabled))
          });
        } else {
          pdfData.zones.push({
            location_name: z.location_name,
            location_id: z.location_id,
            detect_motion: ((z.location_config === undefined || z.location_config.feature_controls === undefined || z.location_config.feature_controls.motion_detection === undefined) || (z.location_config && z.location_config.feature_controls && z.location_config.feature_controls.motion_detection.enabled))
          });
        }

      }
    }

    if (!pdfData.site_selected.site_config || !pdfData.site_selected.site_config.work_hours || !pdfData.site_selected.site_config.work_hours.work_hours_start || !pdfData.site_selected.site_config.work_hours.work_hours_end) {
      pdfData.site_selected.site_config.work_hours = DateUtil.getConfiguredWorkHours(userCopy).work_hours;
    }
    return pdfData;
  };

  let onDateChange = (date) => {
    setDate(moment(new Date(date)).format("YYYY-MM-DD"));
  };

  const chart = {
    data: {
      labels: [],
      datasets: [
        {
          label: "People",
          backgroundColor: "rgba(0,123,255,0.8)",
          borderWidth: 0,
          hoverBackgroundColor: "rgba(0,123,255,0.9)",
          data: [],
        },
      ],
    },
    options: {
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 30,
          bottom: 0,
        },
      },
      legend: {
        display: false,
      },
      responsive: true,
      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              display: false,
            },
            scaleLabel: {
              display: true,
              labelString: "Hour",
              fontColor: "orange",
            },
          },
        ],
        yAxes: [
          {
            display: true,
            gridLines: {
              display: false,
            },
            scaleLabel: {
              display: true,
              labelString: "Max. Person Count",
              fontColor: "orange",
            },
            ticks: {
              min: 0, // it is for ignoring negative step.
              beginAtZero: true,
              callback: function (value, index, values) {
                if (Math.floor(value) === value) {
                  return value;
                }
              },
            },
          },
        ],
      },
      maintainAspectRatio: false,
    },
  };
  return (
    <React.Fragment>

      <div className="modal-header p-2 bg-primary text-white">
        <span className="modal-title">{props.title}</span>
        <div>
          <button type="button" className="fa fa-expand" onClick={props.resizeModal} ></button>
          <button type="button" className="far fa-lg fa-times-circle pull-right" data-dismiss="modal" onClick={props.closeModal} ></button>
        </div>
      </div>

      {!loading && (
        <div className="container px-2 py-1 bg-light">
          <div className="row">
            <div className="col-md-6 font-weight-bold text-primary pt-1 pl-4">
              {user && user.site_selected && user.site_selected.site_name}
            </div>
            <div className="col-md-6 text-right">
              <span className="pr-2"><DownloadReport report_url={sdr_url}></DownloadReport></span>
              {!props.hideDatePicker &&
                <DatePicker disabledDate={(current) => current > moment().endOf('day')} showToday={false} allowClear={false} inputReadOnly popupStyle={{ zIndex: 10000 }} onChange={onDateChange} defaultValue={moment(date, 'YYYY-MM-DD')} format={'YYYY-MM-DD'} />
              }
            </div>
          </div>
        </div>
      )}

      <div className="modal-body bg-white">

        <div className="p-1">
          {loading && (<div> <center> <Loading> Loading ... </Loading> </center> </div>)}
          {!loading && (
            <React.Fragment>
              <table className="table table-bordered border-rounded-t">
                <thead>
                  <tr>
                    <th colSpan="4">
                      Manpower Report (Daily)
                    </th>
                  </tr>
                  <tr className="text-dark bg-light border-1">
                    <th className="p-1">Zone Name</th>
                    <th className="p-1">Max. Person Count</th>
                    <th className="p-1">First Appearance</th>
                    <th className="p-1">Last Appearance</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(zones).map(
                    (w, i) =>
                      ((zones[w].location_config === undefined || zones[w].location_config.feature_controls === undefined || zones[w].location_config.feature_controls.motion_detection === undefined) ||
                        (zones[w].location_config && zones[w].location_config.feature_controls && zones[w].location_config.feature_controls.motion_detection.enabled)) && (
                        <tr className="font-size-12" key={i}>
                          <td className="p-2">
                            {zones[w].location_name}
                          </td>
                          <td className="p-2">
                            {person_info[w] ? person_info[w].max_person_count : 0}
                          </td>
                          <td className="p-2">
                            {person_info[w] ? moment.tz(person_info[w].start_person_ts * 1000, timezone).format("YYYY-MM-DD HH:mm") : 0}
                          </td>
                          <td className="p-2">
                            {person_info[w] ? moment.tz(person_info[w].last_person_ts * 1000, timezone).format("YYYY-MM-DD HH:mm") : 0}
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>

              {chart_data && Object.keys(zones).map((z, i) =>
                ((zones[z].location_config === undefined || zones[z].location_config.feature_controls === undefined || zones[z].location_config.feature_controls.motion_detection === undefined) ||
                  (zones[z].location_config && zones[z].location_config.feature_controls && zones[z].location_config.feature_controls.motion_detection.enabled)) &&
                <React.Fragment key={i}>
                  <div className="card bg-shadow mt-4">
                    <div className="card-header bg-primary text-light p-2">
                      {zones[z]["location_name"]}
                    </div>
                    <div className="card-body text-center">
                      {chart_data[z].personsFound === true ?
                        <div className="bg-lighter" style={{ height: "175px", width: "100%" }} >
                          <Bar
                            style={{ position: "relative" }}
                            data={chart_data && chart_data[z] ? chart_data[z] : []}
                            height={150}
                            options={chart.options}
                          />
                        </div> : "No Person Detected During Work Hours"
                      }
                      {sensor_info[z] && sensor_info[z].length > 0 && sensor_info[z][0].sensorInfo && (
                        <SensorInfo zoneInfo={zones[z]} zone={zones[z]["location_name"]} data={sensor_info[z][0]} images={sensor_info[z][0].images} key={"si_" + i} sensorInfo={sensor_info[z][0].sensorInfo} timezone={timezone} ></SensorInfo>
                      )
                      }
                    </div>
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
      <div className="modal-footer bg-light" style={{ padding: "0.5rem 1rem" }} >
        {/* {!loading && <a target='_blank' rel='noopener noreferrer' onClick={() => { this.handleClick() }} href={this.state.sdr_url} className="btn btn-white btn-sm"><i className="far fa-file-pdf text-danger"></i> Download PDF</a>} */}
      </div>
    </React.Fragment>
  );
}

export default StandardDailyReport;